import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/6980d1b5921dc90014148890/bookreview_hub/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6980d1b5921dc90014148890/bookreview_hub/src/app/book-reviews/components/BookReviewsInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6980d1b5921dc90014148890/bookreview_hub/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6980d1b5921dc90014148890/bookreview_hub/src/components/ui/AppIcon.tsx");
